import React from "react";
import AdminHome from "../../components/admin/AdminHome";

const AdminDashboard = () => {
  return (
    <div>
      <AdminHome />
    </div>
  );
};

export default AdminDashboard;
